import React from 'react';
import PropTypes from 'prop-types';
import FloatingPanel from '../../../components/Panel/FloatingPanel';
import AddNewNoteForm from './AddNewNoteForm';
import { getPhotoCurrentUser } from '../../../service/s3Amplify';
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../Notification/CustomNotification';
class AddNewNote extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      img: '',
      files: [],
      selectedPicture: null,
      errorMessage:'',
      attachment:null,
      openNotification : false,
      messageNotification : 'Selecciona un archivo válido',
      typeNotification : "warning"
    }; 
    this.onDrop = this.onDrop.bind(this);
    this.onClean = this.onClean.bind(this);
    this.addAttachment = this.addAttachment.bind(this);
  }

  onDrop(files,url) {
    if(files.length===0){
      if(url){
          getPhotoCurrentUser(url).then(response =>{
            this.setState({
              urlPreview: response
            });
          }).catch(err =>{
            console.log("error url", err);
          });
      }else{
        this.setState({errorMessage:"archivo inválido"});
      }
    }else{
      let oldFiles = this.state.files;
      const filesLimit = 2;
      oldFiles = oldFiles.concat(files);
      if (oldFiles.length > filesLimit) {
        this.setState({
          errorMessage : 'No puedes subir más de un archivo'
        });
      } else {
        this.setState({ img: files[0].preview , selectedPicture: files[0] ,errorMessage:''});        
      }
    }    
  }

  addAttachment(files){
    if(files[0]){
      this.setState({
        attachment: files[0]
      });
    }else{
      this.setState({
        attachment: null,
        openNotification : true
      });
    }
  }
 
  handleCloseNotification = () => {
    this.setState(
      {
        openNotification : false
      }
    )
  }
  
  deleteSelectedPic=()=>{
    this.setState({ selectedPicture:null,urlPreview:''});
  }

  onClean(columnist){
    this.setState({
      selectedPicture:null,
      errorMessage:'',
      attachment:null,
      urlPreview:''
    });    
  }

  componentWillReceiveProps(newProps){
    if(newProps.dataInit !== null){
      if(newProps.dataInit.cont_imagePath!=="")
        getPhotoCurrentUser(newProps.dataInit.cont_imagePath).then(response =>{
          this.setState({
            urlPreview:response
          });
        }).catch(err =>{
          console.log("error url", err);
        });
    }else{
      this.setState({
        selectedPicture:null,
        attachment:null,
        urlPreview:''
      });
    }
  }

  render() {
    const {
      openForm,
      closeForm,
      dataInit,
      submit,
      action,
      isLoading,
      type,
      dataSelect,
    } = this.props;
    const branch = '';
    return (
      <div>
        <FloatingPanel title={`${action} Nota`} openForm={openForm} branch={branch} closeForm={closeForm}>
          <AddNewNoteForm  
            handleSubmit={(event, data)=>submit(event, data, this.state.selectedPicture, this.state.attachment,this.state.urlPreview)}
            onDrop={this.onDrop}
            preview={this.state.selectedPicture ? this.state.selectedPicture.preview : this.state.urlPreview}
            dataInit={dataInit}
            isOpen={openForm}
            onClean={this.onClean}
            errorMessage={this.state.errorMessage}
            addAttachment={this.addAttachment}
            attachment={this.state.attachment}
            isLoading={isLoading}
            deleteSelectedPic={this.deleteSelectedPic}
            type={type}
            dataSelect={dataSelect}
          />
        </FloatingPanel>
        <Snackbar
         anchorOrigin={{
             vertical: 'top',
             horizontal: 'right',
         }}
         open={this.state.openNotification}
         autoHideDuration={6000}
         onClose={this.handleCloseNotification}>
       <CustomNotification
         onClose={this.handleCloseNotification}
         variant={this.state.typeNotification}
         message={this.state.messageNotification}/>
       </Snackbar>
      </div>
    );
  }
}

AddNewNote.propTypes = {
  classes: PropTypes.object,
  submit: PropTypes.func, 
  openForm: PropTypes.bool, 
  closeForm: PropTypes.func,
  dataInit: PropTypes.object
};

export default (AddNewNote);
